import PropTypes from 'prop-types'

import Loader from '../../../Loader/Loader'

const AnnouncementStaticticsLoader = ({ isLoading }) => {
  if (!isLoading) {
    return null
  }

  return (
    <div className="loader-container">
      <Loader />
    </div>
  )
}

AnnouncementStaticticsLoader.propTypes = {
  isLoading: PropTypes.bool,
}

export default AnnouncementStaticticsLoader
